import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

import { FormContext } from 'modules/workflows/components/Sidepanel/schemas/nodeSidepanelSchema'
import { createTaskFormSchema } from 'modules/workflows/components/Sidepanel/schemas/taskFormSchema'

import { createEmployeeSegmentSchema } from './employeeSegmentSchema'

export const createRequestDocumentHandlerSchema = (formContext: FormContext) => {
  const employeeSegmentSchema = createEmployeeSegmentSchema()

  return createTaskFormSchema(formContext).extend({
    nodeType: z.literal('task'),
    nodeData: z.object({
      handlerType: z.literal('request_document'),
      payload: z
        .object({
          title: z.string().min(1, {
            message: i18n.t('procurement.workflows.basic_task_handler.validation.title_required'),
          }),
          description: z.string().min(1, {
            message: i18n.t(
              'procurement.workflows.basic_task_handler.validation.description_required'
            ),
          }),
          employee_ids: z.array(z.string()).optional(),
          employee_segments: z.array(employeeSegmentSchema).optional(),
          fallback_employee_ids: z.array(z.string()).optional(),
          fallback_employee_segments: z.array(employeeSegmentSchema).optional(),
          due_on_value: z
            .number({
              message: i18n.t(
                'procurement.workflows.basic_task_handler.validation.due_date_min_value'
              ),
            })
            .min(1, {
              message: i18n.t(
                'procurement.workflows.basic_task_handler.validation.due_date_min_value'
              ),
            }),
          due_on_unit: z.enum(['hours', 'days', 'weeks', 'months']),
        })
        .refine(
          (data) => {
            const hasAssignees = !!data.employee_ids?.length
            const hasSegments = !!data.employee_segments?.length
            return hasAssignees || hasSegments
          },
          {
            message: i18n.t(
              'procurement.workflows.basic_task_handler.validation.assignee_required'
            ),
            path: ['employee_ids'],
          }
        ),
    }),
  })
}

export type RequestDocumentHandlerSchema = z.infer<
  ReturnType<typeof createRequestDocumentHandlerSchema>
>
